/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Представляет иконку приложения в манифесте.
 * @export
 * @interface FxIdWebFeaturesPlayManifestResponseIcons
 */
export interface FxIdWebFeaturesPlayManifestResponseIcons {
    /**
     * Путь к картинке значка вместе с расширением.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponseIcons
     */
    Src: string;
    /**
     * MIME-тип значка, обычно image/png.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponseIcons
     */
    Type: string;
    /**
     * Размер значка (например, "512x512", "1024x1024").
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponseIcons
     */
    Sizes: string;
    /**
     * Назначение иконки.
     * Некоторые устройства типа Android, адаптируют значки к разным размерам и формам.
     * Можно задать этому полю св-во "maskable" и сделать значок с более широкими отступами для лучшего отображения.
     * Маскируемые значки должны быть не менее 512x512.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponseIcons
     */
    Purpose?: string | null;
}

/**
 * Check if a given object implements the FxIdWebFeaturesPlayManifestResponseIcons interface.
 */
export function instanceOfFxIdWebFeaturesPlayManifestResponseIcons(value: object): value is FxIdWebFeaturesPlayManifestResponseIcons {
    if (!('Src' in value) || value['Src'] === undefined) return false;
    if (!('Type' in value) || value['Type'] === undefined) return false;
    if (!('Sizes' in value) || value['Sizes'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesPlayManifestResponseIconsFromJSON(json: any): FxIdWebFeaturesPlayManifestResponseIcons {
    return FxIdWebFeaturesPlayManifestResponseIconsFromJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayManifestResponseIconsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesPlayManifestResponseIcons {
    if (json == null) {
        return json;
    }
    return {
        
        'Src': json['src'],
        'Type': json['type'],
        'Sizes': json['sizes'],
        'Purpose': json['purpose'] == null ? undefined : json['purpose'],
    };
}

export function FxIdWebFeaturesPlayManifestResponseIconsToJSON(json: any): FxIdWebFeaturesPlayManifestResponseIcons {
    return FxIdWebFeaturesPlayManifestResponseIconsToJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayManifestResponseIconsToJSONTyped(value?: FxIdWebFeaturesPlayManifestResponseIcons | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'src': value['Src'],
        'type': value['Type'],
        'sizes': value['Sizes'],
        'purpose': value['Purpose'],
    };
}

